import { Breadcrumbs, Dialog, DialogContent, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from '@mui/material';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { useNotification } from '../common/notification/notification';
import ClipLoader from 'react-spinners/ClipLoader';
import { useState } from 'react';
import { patient } from '../common/type';
import { seeNotification } from '../services/post.service';

const Notifications = (props: {setFCount: (count: number) => void}) => {
    const { setFCount } = props
    const { notifications, loading, notificationsCount } = useNotification(setFCount)
    const [open, setOpen] = useState(false)
    const [patient, setPatient] = useState<patient>()
    const [rowsPerPage, setRowsPerPage] = useState(5)
    const [page, setPage] = useState(0);

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const see = (id: number, read: boolean) => {
        if (!read)
            seeNotification(id)
                .catch((err) => {
                    console.log(err)
                })
    }

    return <>
        <Helmet><title>{notificationsCount > 0 ?  '(' + notificationsCount + ') Notification/s' : 'Notification/s'}</title></Helmet>
        <div className="dark:text-black w-full">
            <div className="lg:m-12 m-4">
                <div className="bg-amber50 shadow-md rounded w-full lg:px-20 px-3 py-10 pt-5">
                    <div className="col-span-2">
                        <Breadcrumbs className="pb-5 color: rgb(0 0 0)" aria-label="breadcrumb">
                            <Link
                                color="black"
                                to="/"
                                className="hover:underline color: rgb(0 0 0)"
                            >
                                <Typography>Home</Typography>
                            </Link>
                            <Typography className="text-black">Notifications</Typography>
                        </Breadcrumbs>
                        <Typography variant="h5">{notificationsCount > 0 ? notificationsCount : ''} Notification/s</Typography>
                        <div className="mt-5">
                            {
                                loading
                                    ?
                                    <ClipLoader size={50} />
                                    :
                                    notifications !== null && notifications.length > 0
                                        ?
                                        <TableContainer component={Paper}>
                                            <Table >
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>Message</TableCell>
                                                        <TableCell>Time Stamp</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                {
                                                    notifications.map((notification, index) => (
                                                        <TableBody key={index}>
                                                            <TableRow className={`hover:bg-gray-300 ` + (notification.seen ? 'bg-gray-200' : '')}
                                                                title={'Click to view details'}
                                                                onClick={() => {
                                                                    setOpen(true); setPatient(notification.patient);
                                                                    see(notification.id, notification.seen)
                                                                }}
                                                            >
                                                                <TableCell>{notification.message}</TableCell>
                                                                <TableCell>{new Date(notification.createdAt).toLocaleString()}</TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    ))
                                                }
                                            </Table>
                                            <TablePagination component={"div"} rowsPerPageOptions={[5, 10, 25, 100]} count={notifications.length}
                                                rowsPerPage={rowsPerPage} page={page} onPageChange={handleChangePage}
                                                onRowsPerPageChange={handleChangeRowsPerPage} />
                                        </TableContainer>
                                        :
                                        <Typography align='center' variant='h5' className='text-gray-500'>
                                            No notification
                                        </Typography>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth='md'>
            <DialogContent>
                <Typography align='center' fontWeight={'bold'}>Patient</Typography>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ fontWeight: 'bold' }}>First Name</TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>Middle Name</TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>Last Name</TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>Phone No</TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>Card No</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>{patient?.firstName}</TableCell>
                            <TableCell>{patient?.middleName}</TableCell>
                            <TableCell>{patient?.lastName}</TableCell>
                            <TableCell>{patient?.phoneNumber}</TableCell>
                            <TableCell>{patient?.cardNo}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </DialogContent>
        </Dialog>
    </>;
}

export default Notifications